import { ITaskCompleteCount } from "@mctypes/frontend.types";
import React from "react";
import { CheckIcon } from "..";
import { ActionIcon } from "../CustomIcons/CustomIcons";

const TaskCompletedCount: React.FC<{
  taskCompleteCount: ITaskCompleteCount;
  useActionIcon?: boolean;
  size?: "default" | "large";
}> = ({ taskCompleteCount, useActionIcon, size = "default" }) => {
  const isLarge = size === "large";

  return (
  <>
    {taskCompleteCount != null && taskCompleteCount.totalNr > 0 && (
      <div
        className="greybadge"
        style={{
          backgroundColor: taskCompleteCount.darkText ? "#E0E0E0" : "#4B4B4B",
          borderRadius: "10px",
          padding: "2px 8px",
        }}
      >
        <div
          className={`d-flex align-items-center ${taskCompleteCount.darkText ? "" : "text-white"}`}
          style={{ fontSize: isLarge ? "12px" : "11px" }}
        >
          {taskCompleteCount.totalNr > 0 && (
            <>
              {taskCompleteCount.showWarning && <i className="fa fa-warning text-danger" />}
              <span style={{ marginRight: "1px", display: "inline-flex", alignItems: "center" }}>
                {useActionIcon ? (
                  <ActionIcon style={{ fontSize: isLarge ? "1.45em" : "1.3em", margin: " -2px 1px" }} />
                ) : (
                  <span
                    style={{
                      display: "inline-flex",
                      transform: isLarge ? "translateX(-1px) scale(1.1)" : "translateX(-1px)",
                    }}
                  >
                    <CheckIcon completedNr={taskCompleteCount.completedCount} totalNr={taskCompleteCount.totalNr} />
                  </span>
                )}
              </span>
              <span>{taskCompleteCount.completedCount}</span>
              <span style={{ margin: "0 1px" }}>/</span>
              <span>{taskCompleteCount.totalNr}</span>
            </>
          )}
        </div>
      </div>
    )}
  </>
  );
};
export default TaskCompletedCount;
